/**
 * Countries with a 25% increased per diem rate under Israeli tax regulations.
 *
 * Shared by the per diem calculation (RefundReportContext) and the country
 * dropdown (CountrySelector) so the premium markers and the math never drift.
 *
 * 'USA' and 'United States' are both listed because legacy saved data uses
 * 'USA' while the city lookup and the current country list use 'United States'.
 */
export const COUNTRIES_WITH_PREMIUM_RATE: string[] = [
  'Austria', 'Australia', 'Italy', 'Iceland', 'Ireland', 'Japan', 'South Korea',
  'Switzerland', 'United Kingdom', 'Belgium', 'Germany', 'Denmark', 'Netherlands',
  'Norway', 'Sweden', 'Finland', 'France', 'Hong Kong', 'Singapore', 'Canada', 'USA',
  'United States',
];

export function isPremiumRateCountry(country: string): boolean {
  const normalized = country.toLowerCase();
  return COUNTRIES_WITH_PREMIUM_RATE.some(
    premiumCountry => normalized.includes(premiumCountry.toLowerCase())
  );
}
